var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"px-4 py-4 ",staticStyle:{"color":"trasnperent"},style:([{ width: _vm.width, maxWidth: _vm.width, left: _vm.left }])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }